import React, { useState, useEffect } from 'react';
import { ArrowLeft, Users, Search } from 'react-feather';
import styles from '../Writes.module.scss';
import {
    GET_CLASS_STUDENTS,
    ASSIGN_STUDENTS_TO_GROUP,
    GET_GROUPS,
    CREATE_GROUP,
} from '../services/graphql';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import cx from 'classnames';
import studentGenericAvatar from '../../../images/loader-boomer.png';
import { Modal, Button } from '@squirrellearningltd/go-teacher-components';
import { useEffectOnce } from 'react-use';
import { useNavigate } from '@reach/router';

const AddStudentsToGroup = ({
    selectedGroup,
    teacherStudentClasses,
    navigateBack,
    schoolId,
}) => {
    // Internal props
    const [selectedClass, setSelectedClass] = useState(
        teacherStudentClasses[0].id
    );
    const [searchTherm, setSearchTherm] = useState('');
    const [visibleStudents, setVisibileStudents] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [groupName, setGroupname] = useState(undefined);
    const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
    const navigate = useNavigate();

    // Data handling
    const [getClassStudents, { data, error, loading }] = useLazyQuery(
        GET_CLASS_STUDENTS,
        {
            variables: {
                id: selectedClass,
            },
            onCompleted: ({ studentsClass }) =>
                setVisibileStudents(studentsClass.students),
        }
    );

    const [addStudentsToGroup, { loading: addStudentsToGroupLoading }] =
        useMutation(ASSIGN_STUDENTS_TO_GROUP, {
            variables: {
                groupId: selectedGroup ? selectedGroup.id : undefined,
                studentIds: selectedStudents,
            },
            onCompleted: () => {
                alert(
                    `${
                        selectedStudents.length > 1
                            ? 'Students were'
                            : 'Student was'
                    } added to the group.`
                );
                setSelectedStudents([]);
            },
            onError: () => {
                alert(
                    `${
                        selectedStudents.length > 1
                            ? 'Students were'
                            : 'Student was'
                    } not added to the group.`
                );
                setSelectedStudents([]);
            },
            refetchQueries: [
                {
                    query: GET_GROUPS,
                    variables: {
                        schoolId: schoolId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        });

    const [createGroup, { loading: createGroupLoading }] = useMutation(
        CREATE_GROUP,
        {
            variables: {
                schoolId: schoolId,
                studentsClassId: selectedClass,
                name: groupName,
                studentsIds: selectedStudents,
            },
            onError: () => {
                alert('The group could not be created. Please try again.');
            },
            onCompleted: () => {
                alert('Group was successfully created.');
                navigate('/startWrite/manageGroups');
            },
            refetchQueries: [
                {
                    query: GET_GROUPS,
                    variables: {
                        schoolId: schoolId,
                    },
                },
            ],
            awaitRefetchQueries: true,
        }
    );

    // Functions
    const onSelectStudent = (e) => {
        if (selectedStudents.indexOf(e.target.value) !== -1) {
            setSelectedStudents(
                selectedStudents.filter((s) => s !== e.target.value)
            );
        } else {
            setSelectedStudents([...selectedStudents, e.target.value]);
        }
    };

    // Effects
    useEffect(() => {
        const results = searchTherm
            ? visibleStudents.filter((student) =>
                  student.displayName
                      .toLowerCase()
                      .includes(searchTherm.toLowerCase())
              )
            : data?.studentsClass?.students
            ? data.studentsClass.students
            : [];
        setVisibileStudents(results);
    }, [searchTherm, data]);

    useEffectOnce(() => {
        getClassStudents();
    });

    if (loading) {
        return <p>Loading students...</p>;
    }

    if (error) {
        return <p>Could not load the students. Please try again.</p>;
    }

    return (
        <>
            <div className='page-header'>
                <div className='page-header__content'>
                    <div className='page-header__content__inner'>
                        <h2 className='page-header__content__title'>
                            <Users />
                            Group student select
                        </h2>
                    </div>
                </div>
                <div className='page-header__actions'>
                    <button
                        className='u-display-flex u-align-center u-text-dark'
                        onClick={navigateBack}
                    >
                        <ArrowLeft className='u-m-right-1' /> Back
                    </button>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-4'>
                    <input
                        className={`${styles.utilitiesBtn} basic-form__text-box u-align-center`}
                        type='search'
                        placeholder='Search'
                        onChange={(e) => setSearchTherm(e.target.value)}
                        value={searchTherm}
                    />
                    {!searchTherm && (
                        <Search
                            size={20}
                            className={styles.utilitiesSearchIcon}
                        />
                    )}
                </div>

                <div className='col-md-4'>
                    <div className='basic-form__group'>
                        <select
                            onChange={(e) => {
                                setSelectedClass(e.target.value);
                                getClassStudents();
                            }}
                            name='type'
                            className='basic-form__text-select u-display-block'
                        >
                            {teacherStudentClasses.map((teacherClass) => {
                                return (
                                    <option
                                        key={teacherClass}
                                        value={teacherClass.id}
                                    >
                                        {teacherClass.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            </div>
            {!selectedGroup ? (
                <p>
                    Please select a minimum of 5 students in order to create a
                    group.
                </p>
            ) : (
                <></>
            )}
            <div className='row'>
                {visibleStudents.map((student, index) => {
                    return (
                        <div
                            key={index}
                            className={cx(
                                'col-lg-4 col-md-6',
                                styles.boomerCardContainer
                            )}
                        >
                            <div className='card card-hover'>
                                <div
                                    className={
                                        styles.boomerCardContainerContent
                                    }
                                >
                                    <div
                                        className={cx(
                                            'basic-form__group--check',
                                            styles.stCheck,
                                            styles.stCheckTop
                                        )}
                                    >
                                        <input
                                            name='student'
                                            className='basic-form__check-box'
                                            type='checkbox'
                                            value={student.id}
                                            onChange={(e) => onSelectStudent(e)}
                                            checked={
                                                selectedStudents.indexOf(
                                                    student.id
                                                ) > -1
                                            }
                                            id={`st_${student.id}`}
                                        />
                                        <label
                                            className='basic-form__check-label'
                                            htmlFor={`st_${student.id}`}
                                        >
                                            &nbsp;
                                        </label>
                                    </div>

                                    <div
                                        className={
                                            styles.boomerCardContainerAvatar
                                        }
                                    >
                                        <img
                                            src={
                                                student.boomerAvatarUrl
                                                    ? student.boomerAvatarUrl
                                                    : studentGenericAvatar
                                            }
                                            alt='Student Avatar'
                                        ></img>
                                    </div>
                                    <div
                                        className={
                                            styles.boomerCardContainerName
                                        }
                                    >
                                        {student.displayName}
                                    </div>

                                    <div
                                        className={
                                            styles.boomerCardContainerWritingProject
                                        }
                                    >
                                        {student.classes && student.classes.length ? student.classes[0].name : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={styles.writesFooter}>
                <Button
                    disabled={
                        addStudentsToGroupLoading ||
                        !selectedStudents.length ||
                        (!selectedGroup &&
                            (selectedStudents.length < 5 || createGroupLoading))
                    }
                    onClick={() => {
                        selectedGroup
                            ? addStudentsToGroup()
                            : setShowCreateGroupModal(true);
                    }}
                    className='btn btn-primary'
                >
                    {selectedGroup ? 'Add to Group' : 'Create Group'}
                </Button>
            </div>

            {showCreateGroupModal && (
                <Modal
                    closeModal={() => {
                        setShowCreateGroupModal(false);
                        setGroupname(undefined);
                    }}
                >
                    <h3>Please provide a group name</h3>
                    <input
                        type='text'
                        onChange={(e) => setGroupname(e.target.value)}
                        className='basic-form__text-box'
                    />

                    <Button
                        disabled={!groupName}
                        onClick={() => {
                            createGroup();
                            setShowCreateGroupModal(false);
                            setGroupname(undefined);
                        }}
                    >
                        Create Group
                    </Button>
                </Modal>
            )}
        </>
    );
};

export default AddStudentsToGroup;
